// extracted by css-extract-rspack-plugin
export default {"StyledSyncedParametersList":"pjCgn","StyledDebouncedFrame":"fHfxY","QueryBuilderMain":"xewzp","isSidebarOpen":"zKwbk","Footer":"pIlw9"};